<div *ngIf="element" class="p-fluid">
  <!-- Interaction Label Section -->
  <div class="p-field p-mb-4">
    <h6 class="p-text-bold p-mb-1">Interaction label <span class="required">*</span></h6>
    <small class="p-d-block p-mb-3 p-text-muted">This will be the name of the button for this interaction</small>
    <input id="interaction-label" type="text" pInputText [(ngModel)]="element.label" (ngModelChange)="elementChange.emit()" placeholder="Label">
  </div>
  
  <!-- Weather Announcement Section -->
  <div class="p-field p-mb-4">
    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
      <h6 class="p-text-bold p-m-0">Weather announcement</h6>
      <p-inputSwitch
        [(ngModel)]="element.weatherAnnouncement"
        (onChange)="onWeatherAnnouncementToggle()"
        [ngModelOptions]="{standalone: true}">
      </p-inputSwitch>
    </div>
    <small class="p-d-block p-mb-3 p-text-muted">Voice over dynamically generated based on user location and current weather</small>
  </div>

  <!-- Text to Speak Section -->
  <div class="p-field p-mb-4" *ngIf="!element.weatherAnnouncement">
    <h6 class="p-text-bold p-mb-1">Enter Text to Speak</h6>
    <small class="p-d-block p-mb-3 p-text-muted">Type what you'd like converted into spoken audio.</small>
    <textarea id="interaction-text" [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize" [(ngModel)]="element.text" (ngModelChange)="elementChange.emit()" placeholder="Type what you'd like converted into spoken audio.">
    </textarea>
    
    <div class="p-field p-mt-3">
      <h6 class="p-text-bold p-mb-1">After text ends</h6>
      <small class="p-d-block p-mb-3 p-text-muted">Choose what happens when the speech finishes</small>
      <p-selectButton [options]="textBehaviorOptions"
                     [(ngModel)]="element.textBehavior"
                     (onChange)="elementChange.emit()"
                     optionLabel="label"
                     optionValue="value">
      </p-selectButton>
    </div>
  </div>

  <!-- Call to Action Section -->
  <div class="p-mb-4">
    <app-call-to-action [feature]="element"></app-call-to-action>
  </div>

  <!-- Character Animation Section -->
  <div class="p-field p-mb-4">
    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
      <h6 class="p-text-bold p-m-0">Character's animation</h6>
      <p-inputSwitch
        [(ngModel)]="element.animationsEnabled"
        (onChange)="onAnimationsToggle()"
        [ngModelOptions]="{standalone: true}">
      </p-inputSwitch>
    </div>
    <small class="p-d-block p-mb-3 p-text-muted">Choose your character's movements</small>
    
    <div class="animation-container p-mt-3" *ngIf="element.animationsEnabled">
      <div class="animation-layout">
        <div class="preview-section">
          <app-threejs-viewer
            [modelUrl]="selectedModelUrl"
            [animationUrl]="selectedAnimationUrl"
            class="model-viewer-large">
          </app-threejs-viewer>
        </div>
        
        <div class="controls-section">
          <div class="p-mb-3">
            <p-button
              label="Upload animation"
              icon="pi pi-upload"
              (click)="showUploadModal()"
              styleClass="p-button-primary p-mb-2">
            </p-button>
            <small class="p-d-block p-text-muted">Formats GLB, GLTF. Limit of 50 mb</small>
          </div>
          
          <div class="p-field p-mb-3">
            <h6 class="p-text-bold p-mb-2">Animation type:</h6>
            <p-selectButton [options]="animationTypeOptions"
                           [(ngModel)]="selectedAnimationType"
                           (onChange)="onAnimationTypeChange()"
                           optionLabel="label"
                           optionValue="value">
            </p-selectButton>
          </div>
          
          <div class="p-field p-mb-3">
            <h6 class="p-text-bold p-mb-2">Select animation:</h6>
            <p-dropdown [options]="filteredAnimations"
                       [(ngModel)]="element.animation"
                       (onChange)="onAnimationDropdownChange($event.value)"
                       optionLabel="label"
                       [filter]="true"
                       filterBy="label"
                       [showClear]="true"
                       placeholder="Choose an animation"
                       styleClass="w-full">
              <ng-template pTemplate="selectedItem">
                <div *ngIf="element.animation" class="selected-animation-item">
                  <span>{{ element.animation.label }}</span>
                  <span *ngIf="element.animation.isCustom" class="custom-badge">Custom</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-animation>
                <div class="animation-dropdown-item">
                  <div class="animation-info">
                    <span class="animation-name">{{ animation.label }}</span>
                    <span *ngIf="animation.isCustom" class="custom-badge">Custom</span>
                  </div>
                  <p-button *ngIf="animation.isCustom"
                           icon="pi pi-trash"
                           (click)="deleteAnimationFromDropdown(animation, $event)"
                           severity="danger"
                           [text]="true"
                           size="small"
                           class="delete-button-dropdown">
                  </p-button>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="p-field">
            <h6 class="p-text-bold p-mb-2">After animation ends:</h6>
            <p-selectButton [options]="animationBehaviorOptions"
                           [(ngModel)]="element.animationBehavior"
                           (onChange)="elementChange.emit()"
                           optionLabel="label"
                           optionValue="value">
            </p-selectButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Replace the existing upload modal -->
<app-upload-modal
  [(visible)]="uploadModalVisible"
  [steps]="uploadSteps"
  [activeStep]="activeStep"
  [uploadStatus]="uploadStatus"
  [uploadProgress]="uploadProgress"
  [style]="{width: '600px'}"
  [contentStyle]="{'padding': '0'}"
  [canProceed]="canProceed()"
  (close)="closeUploadModal()"
  (back)="onBack()"
  [showCloseButton]="false"
  [primaryButtonLabel]="getPrimaryButtonLabel()"
  (finish)="onFinish()">
  
  <!-- Step content -->
  <ng-container [ngSwitch]="activeStep">
    <!-- Step 1: Animation Upload -->
    <div *ngSwitchCase="0" class="upload-step">
      <p-fileUpload
        #fileUpload
        mode="basic"
        chooseLabel="Select Animation File"
        [auto]="true"
        accept=".glb,.gltf"
        [maxFileSize]="50000000"
        (onSelect)="onAnimationUpload($event)">
      </p-fileUpload>

      <div *ngIf="animationPreviewUrl" class="preview-container">
        <div class="preview-label">Preview:</div>
        <app-threejs-viewer 
          [modelUrl]="selectedModelUrl" 
          [animationUrl]="animationPreviewUrl" 
          class="animation-preview">
        </app-threejs-viewer>
      </div>
    </div>

    <!-- Step 2: Name -->
    <div *ngSwitchCase="1" class="upload-step">
      <div class="name-input-container">
        <label for="animationName">Animation Name</label>
        <input 
          id="animationName"
          type="text" 
          pInputText 
          [(ngModel)]="animationName"
          (ngModelChange)="validateAnimationNameInput($event)"
          [class.p-invalid]="nameError"
          placeholder="Enter animation name (letters, numbers, - and _ only)">
        <div class="messages">
          <small class="error-message" *ngIf="nameError">{{nameError}}</small>
          <small class="hint">This name will be used to identify your animation</small>
        </div>
      </div>
    </div>
  </ng-container>
</app-upload-modal>

<!-- Add this at the bottom of the file -->
<app-confirmation-dialog
  [(visible)]="showDeleteConfirmation"
  [message]="deleteConfirmationMessage"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-confirmation-dialog>

<!-- Close confirmation dialog -->
<app-confirmation-dialog
  [(visible)]="showCloseConfirmation"
  [message]="closeConfirmationMessage"
  [title]="'Discard Upload'"
  [confirmButtonText]="'Discard'"
  (confirm)="onCloseConfirm()"
  (cancel)="onCloseCancel()">
</app-confirmation-dialog>